import { SessionStorageKeys } from '@invision/core';

/**
 * Storage Keys for Authentication Module
 *
 * These keys are imported from the Core module to ensure consistency
 * with existing Core module expectations for session management.
 */
export const STORAGE_KEYS = {
  /** Core module session ID key: 'invision-sessionId' */
  SESSION_ID: SessionStorageKeys.SESSION_SESSION_ID_KEY,

  /** Core module system ID key: 'invision-systemId' */
  SYSTEM_ID: SessionStorageKeys.SESSION_SYSTEM_ID_KEY,

  /** Core module environment key: 'invision-environment' */
  ENVIRONMENT: SessionStorageKeys.ENVIRONMENT_KEY,

  /** Core module authentication redirect key: 'invision-authentication-redirect' */
  AUTHENTICATION_REDIRECT: SessionStorageKeys.AUTHENTICATION_REDIRECT_KEY,

  /**
   * Tab-scoped React-auth opt-in: 'invision-auth-mode'.
   * Only stores {@link SessionStorageKeys.AUTH_MODE_REACT}; absence means Angular.
   *
   * TODO(AB#1355453): Remove with the auth-mode opt-in once React auth is the
   * default in every environment.
   */
  AUTH_MODE: SessionStorageKeys.AUTH_MODE_KEY
} as const;

/**
 * Prefix of the cached provider user and request state entries oidc-client-ts
 * writes. Passed to every WebStorageStateStore the OAuth flow creates, which
 * keeps those entries in the authentication namespace and within reach of
 * AuthenticationStorage.clearOAuthFlow().
 */
export const OIDC_CLIENT_STORAGE_KEY_PREFIX = 'authentication:oidc.';

/**
 * Default prefix oidc-client-ts used before the callback pinned an explicit
 * store. Cleared on logout and abandon so pre-deploy leftovers cannot survive.
 */
export const LEGACY_OIDC_CLIENT_STORAGE_KEY_PREFIX = 'oidc.';

/** Authentication module specific storage keys */
export const AUTH_STORAGE_KEYS = {
  /** Last entered username for UX convenience: 'authentication:lastUsername' */
  LAST_USERNAME: 'authentication:lastUsername',
  /** IDP authentication state for callback processing: 'authentication:idpState' */
  IDP_STATE: 'authentication:idpState',
  /** OAuth UserManager settings for callback processing: 'authentication:oauthSettings' */
  OAUTH_SETTINGS: 'authentication:oauthSettings'
} as const;
